export default {
  error: 'error',
  success: 'success',
  info: 'info',
};
